import { DecimalRangeOptions } from "src/app/common/validators/decimal-range.validator";
import { SelectFieldOption } from "src/app/shared/ui/form-fields/select-field/select-field.component";

export const AGS_PATTERN = /^\d{8}$/;
export const AGS_LENGTH = 8;
export const MUNICIPALITY_NAME_MAX_LENGTH = 255;
/** At least one non-whitespace character; `Validators.required` alone lets a blank name through. */
export const MUNICIPALITY_NAME_PATTERN = /\S/;
export const LONGITUDE_RULES: DecimalRangeOptions = { min: -180, max: 180, maxDecimals: 10 };
export const LATITUDE_RULES: DecimalRangeOptions = { min: -90, max: 90, maxDecimals: 10 };
export const DEFAULT_ZOOM_LEVEL = "60";
export const ZOOM_LEVEL_OPTIONS: Array<SelectFieldOption> = [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 40, 60].map(
  (level) => ({ value: `${level}`, label: `${level}` })
);
export const CREATE_MUNICIPALITY_I18N = "CONFIGURATION_AREA.DIALOGS.CREATE_MUNICIPALITY";
